const routes = [
  {
    path: '/reports/activity',
    name: 'reports/activity',
    component: () => import('@/views/Company/Reports/ActivityReport.vue'),
    meta: {
      requiresAuth: true,
      key: '8001',
      pageTitle: 'Activity Report',
      breadcrumb: [
        {
          text: 'Reports',
          active: false,
        },
        {
          text: 'Activity Reports',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports/user-activity-tracking-report',
    name: 'reports/user-activity-tracking-report',
    component: () => import('@/views/Company/Reports/UserTrackingActivityReport.vue'),
    meta: {
      requiresAuth: true,
      key: '8002',
      pageTitle: 'User Tracking Activity Report',
      breadcrumb: [
        {
          text: 'Reports',
          active: false,
        },
        {
          text: 'User Activity Tracking Reports',
          active: true,
        },
      ],
    },
  },
]

export default routes
